<template>
  <div class="about-us awards" id="awards">
    <header class="page-header" data-aos="fade-up">
      <div class="video-container">
        <video class="header-video" src="static/img/about-us/falcon.mp4" autoplay loop></video>
      </div>
      <div class="container">
        <div v-html="$t('certs.headingTopText')" class="heading-text" data-aos="fade-up">
        </div>
      </div>
    </header>
    <div class="certs">
      <div
        v-for="cert in certs"
        :key="cert.key"
        class="elements"
        @click="openCert(cert)"
      >
        <img class="isoDetails" :src="cert.img" :alt="cert.alt" />
      </div>
    </div>
    <footer-main/>
  </div>
</template>

<script>
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import MediaBox from '../components/MediaBox';

  export default {
    name: 'certificates',
    data() {
      return {
        popupActivo: false,
        popupActivo2: false,
      }
    },
    props: [],
    methods: {
      openCert(cert) {
        window.open(cert.pdf, '_blank');
      },
    },
    components: {
      FooterMain,
      FooterMoreInformation,
      MediaBox
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
    certs() {
      const base = 'static/certificates/full';
      const isPl = this.lang === 'pl';

      return [
        {
          key: 'iso45001',
          alt: 'ISO 45001',
          img: `${base}/${isPl ? 'ISO-45001-PL.png' : 'ISO-45001-ENG.png'}`,
          pdf: `${base}/${isPl ? 'ISO-45001-PL.pdf' : 'ISO-45001-ENG.pdf'}`,
        },
        {
          key: 'iso27001',
          alt: 'ISO 27001',
          img: `${base}/${isPl ? 'ISO-IEC-27001-PL.png' : 'ISO-IEC-27001-ENG.png'}`,
          pdf: `${base}/${isPl ? 'ISO-IEC-27001-PL.pdf' : 'ISO-IEC-27001-ENG.pdf'}`,
        },
        {
          key: 'iso14001',
          alt: 'ISO 14001',
          img: `${base}/${isPl ? 'ISO_14001-POL.png' : 'ISO_14001-ENG.png'}`,
          pdf: `${base}/${isPl ? 'ISO_14001-POL.pdf' : 'ISO_14001-ENG.pdf'}`,
        },
        {
          key: 'iso9001',
          alt: 'ISO 9001',
          img: `${base}/${isPl ? 'ISO_9001-POL.png' : 'ISO_9001-ENG.png'}`,
          pdf: `${base}/${isPl ? 'ISO_9001-POL.pdf' : 'ISO_9001-ENG.pdf'}`,
        },
      ];
    },
    }
  }
</script>

<style scoped="">
  .isoDetails{
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    display: block;
    -webkit-box-shadow: 1px 5px 13px -4px rgba(66, 68, 90, 1);
    -moz-box-shadow: 1px 5px 13px -4px rgba(66, 68, 90, 1);
    box-shadow: 1px 5px 13px -4px rgba(66, 68, 90, 1);
  }

  .certs {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 60px;
    gap: 50px;
  }
  .elements {
    cursor: pointer;
  }

  .awards header.page-header {
    min-height: 300px;
  }

</style>



// WEBPACK FOOTER //
// Certificates.vue?49a5bef5